import { getAuthToken } from "@helpers/auth-provider";
import { isWeb } from "@memorang/helpers/platform";
import { authHeaders } from "@memorang/ui/contexts/AuthTokenContext";
import { fetch as expoFetch } from "expo/fetch";

export const agentStreamFetch: typeof globalThis.fetch = async (
	input,
	init,
) => {
	const token = await getAuthToken();
	const headers = new Headers(init?.headers);
	if (token) {
		const auth = authHeaders(token);
		if (auth) {
			headers.set("Authorization", auth.Authorization);
		}
	}
	headers.set("Accept", "text/event-stream");
	const f = (isWeb ? globalThis.fetch : expoFetch) as typeof globalThis.fetch;
	return f(input, { ...init, headers });
};
